import React from 'react';
import { MediaStack } from './MediaStack';
import { normalizeMediaSource } from './mediaSource';
import { VariableMediaRefresh } from './VariableImage';
import { isSlotAwaitingImage, MEDIA_OBJECT_SLOT } from '../utils/imageSlots';
import placeholder from './variable-image-placeholder.svg';

export default function IllustrationMedia({ media, alt = '', isEditing = false, blockId, path, mediaFit = 'contain', mediaAspectRatio = 'auto' }) {
  const resolved = normalizeMediaSource(media);
  if (resolved.kind === 'embed') return null;
  const awaiting = isSlotAwaitingImage(resolved, MEDIA_OBJECT_SLOT);
  if (awaiting && !isEditing) return null;
  const shown = awaiting ? { ...resolved, src: placeholder, kind: 'image' } : resolved;
  return (
    <div style={{ position: 'relative' }}>
      <MediaStack
        media={{ ...shown, srcset: shown.srcVariable?.variableKey ? '' : shown.srcset, playback: { controls: true, autoplay: false, loop: false, muted: false } }}
        stopOnUnmount
        mediaFit={mediaFit}
        mediaAspectRatio={mediaAspectRatio}
        isEditing={isEditing}
        alt={alt}
      />
      <VariableMediaRefresh blockId={blockId} path={path} media={resolved} isEditing={isEditing} />
    </div>
  );
}
